export default __webpack_public_path__ + "static/media/snow-day.abfd36a2.jpg";